import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Sarah Chen',
  role: 'Software Engineer',
  initials: 'SC',
  color: '#1566FF',
  quote: "FinanceAI completely changed how I think about money. The AI chat is like having a financial advisor in my pocket. I've saved $8,000 more this year than last!",
  stars: 5
}, {
  name: 'Marcus Williams',
  role: 'Small Business Owner',
  initials: 'MW',
  color: '#39E75F',
  quote: 'The investment insights are incredible. It spotted that my crypto allocation was too high and suggested rebalancing — my portfolio is up 34% since I followed the advice.',
  stars: 5
}, {
  name: 'Priya Patel',
  role: 'Graduate Student',
  initials: 'PP',
  color: '#F59E0B',
  quote: 'As a student on a tight budget, this app is a lifesaver. The budget alerts keep me on track and the goal planner helped me save for my first apartment deposit.',
  stars: 5
}];
export function TestimonialsSection() {
  return <section className="py-20 bg-gray-50 dark:bg-dark-bg" data-id="element-938">
      <div className="max-w-7xl mx-auto px-4 sm:px-6" data-id="element-939">
        <div className="text-center mb-14" data-id="element-940">
          <p className="text-sm font-semibold text-primary-500 uppercase tracking-widest mb-3" data-id="element-941">
            Testimonials
          </p>
          <h2 className="text-3xl sm:text-4xl font-black text-gray-900 dark:text-white mb-4" data-id="element-942">
            Loved by people who
            <br data-id="element-943" />
            take money seriously
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-944">
          {testimonials.map((t, i) => <div key={i} className="bg-white dark:bg-dark-card rounded-2xl p-6 border border-gray-100 dark:border-dark-border shadow-sm hover:shadow-md transition-shadow" data-id="element-945">
              <div className="flex items-center gap-1 mb-4" data-id="element-946">
                {[...Array(t.stars)].map((_, j) => <Star key={j} size={14} className="text-accent-500 fill-accent-500" data-id="element-947" />)}
              </div>
              <p className="text-sm text-gray-700 dark:text-gray-300 leading-relaxed mb-5" data-id="element-948">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-3" data-id="element-949">
                <div className="w-10 h-10 rounded-full flex items-center justify-center text-white text-sm font-bold" style={{
              backgroundColor: t.color
            }} data-id="element-950">
                  {t.initials}
                </div>
                <div data-id="element-951">
                  <p className="text-sm font-semibold text-gray-900 dark:text-white" data-id="element-952">
                    {t.name}
                  </p>
                  <p className="text-xs text-gray-400" data-id="element-953">{t.role}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}